import { cn } from '@/lib/utils';
import { RadioGroup } from '@headlessui/react';
import { CheckCircleIcon } from '@heroicons/react/24/solid';
import React from 'react';

type Props = {
  patients: {
    ID: string;
    fname: string;
    lname: string;
  }[];
  onChange: (patient: string) => void;
  value: string | null;
};

const SchedulePatients: React.FC<Props> = ({ patients, onChange, value }) => {
  const hasOne = patients?.length === 1;

  return (
    <RadioGroup
      value={value}
      onChange={onChange}
      id="patients"
      defaultValue={hasOne ? `${patients[0].ID}` : 'no-preference'}
    >
      <RadioGroup.Label>
        <div className="flex items-center gap-1">
          <span className="text-sm text-gray-900 whitespace-nowrap">
            {hasOne ? '' : 'Who is this appointment for?'}
          </span>
          <div className="w-full border-t border-gray-300 grow ml-2" />
        </div>
      </RadioGroup.Label>
      <div className="mt-4 grid grid-cols-1 gap-y-2 sm:gap-y-2">
        {patients?.map(patient => (
          <RadioGroup.Option
            key={patient.ID}
            value={patient.ID}
            disabled={hasOne}
            className={({ checked, active }) =>
              cn(
                patient.ID !== 'no-preference' && 'shadow-sm',
                checked || patient.ID === 'no-preference'
                  ? 'border-transparent'
                  : 'border-gray-300',
                active ? 'border-primary ring-2 ring-primary' : '',
                'relative flex cursor-pointer rounded-lg border bg-white p-4 focus:outline-none',
                patient.ID === 'no-preference' ? 'sm:col-span-2' : ''
              )
            }
          >
            {({ checked, active }) => (
              <>
                <span className="flex flex-1">
                  <div className="flex gap-x-4">
                    <div className="min-w-0 flex-auto text-left">
                      <RadioGroup.Label
                        as="span"
                        className="text-sm font-semibold leading-6 text-gray-900"
                      >
                        <span className="absolute inset-x-0 -top-px bottom-0" />
                        {patient.fname} {patient.lname}
                      </RadioGroup.Label>
                      {/* <RadioGroup.Description
                          as="span"
                          className="mt-1 flex text-xs leading-5 text-gray-500"
                        >
                          <span className="relative truncate">
                            Whatever...
                          </span>
                        </RadioGroup.Description> */}
                    </div>
                  </div>
                </span>
                <CheckCircleIcon
                  className={cn(hasOne || checked ? 'h-5 w-5 text-primary' : 'hidden')}
                  aria-hidden="true"
                />
                <span
                  className={cn(
                    active ? 'border' : 'border-2',
                    checked || hasOne ? 'border-primary' : 'border-transparent',
                    'pointer-events-none absolute -inset-px rounded-lg'
                  )}
                  aria-hidden="true"
                />
              </>
            )}
          </RadioGroup.Option>
        ))}
      </div>
    </RadioGroup>
  );
};

export default SchedulePatients;
